import { Box, HStack, Separator, Text } from '@chakra-ui/react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useAuth } from '@/hooks/auth/useAuth';
import { googleLoginService } from '@/services/auth';

const GoogleLoginButtonInner = () => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { setSession } = useAuth();
  const from = (location.state as { from?: Location })?.from?.pathname;

  return (
    <Box>
      <HStack>
        <Separator flex="1" />
        <Text color="fg.muted" textStyle="sm">
          ou
        </Text>
        <Separator flex="1" />
      </HStack>
      <Box mt="4" display="flex" justifyContent="center">
        <GoogleLogin
          onSuccess={async (response) => {
            if (!response.credential) return;
            try {
              const session = await googleLoginService({ id_token: response.credential });
              setSession(session);
              navigate(from ?? '/painel/agendas');
            } catch {
              setError('Erro ao autenticar com o Google. Tente novamente.');
            }
          }}
          onError={() => {
            setError('Erro ao entrar com o Google. Tente novamente.');
          }}
        />
      </Box>
      {error && (
        <Text color="red.500" textStyle="sm" mt="2">
          {error}
        </Text>
      )}
    </Box>
  );
};

const GoogleLoginButton = () => (
  <GoogleOAuthProvider
    clientId={import.meta.env.VITE_CLIENT_ID_GOOGLE}
  >
    <GoogleLoginButtonInner />
  </GoogleOAuthProvider>
);

export default GoogleLoginButton;
